import axiosInstance from "services/axiosMiddleware";

export async function getLibrary(couchId){
    try{
        const response = await axiosInstance.post('library/getLibrary', couchId);
        return response.data;
        
    }catch (error) {
    console.error('Error fetching Asana data:', error);
    throw error; 
  }
}